<template>
  <div>  
    <lock-loading v-if="lock" />
    <div v-else
         class="row no-gutters app-wrapper position-relative"
         :class="[...wrapperClass]">    
      <AppHeader v-if="isLoggedIn && ['acessar_cartorio', 'Atendimento'].indexOf(this.$route.name) === -1"
                 :module="module" />

      <SideBarModules v-if="getSidebarStatus && ['acessar_cartorio', 'Atendimento', 'login'].indexOf($route.name) === -1"
                      :module="module" />

      <AppSubHeader v-if="isLoggedIn && ['acessar_cartorio', 'Atendimento'].indexOf(this.$route.name) === -1 && module.name == 'sofiaRei'" />

      <SideBarReleasesNotes v-if="isLoggedIn && ['acessar_cartorio', 'Atendimento'].indexOf(this.$route.name) === -1 && module.name == 'sofiaRei'" />

      <main class="align-self-center w-100">
        <router-view :key="$route.fullPath" />
      </main>

      <AppFooter v-if="['acessar_cartorio'].indexOf(this.$route.name) === -1 && !lock" />
      <Loader />

      <b-modal id="previewModal"
               hide-header
               ok-title="Fechar"
               ok-only
               size="lg"
               @hidden="clearPreview">
        <figure v-if="!fileType"
                class="boxImg">
          <img alt="Imagem de preview"
               class="boxImg_img w-100 mw-100"
               :src="getPreview.url">
        </figure>

        <div v-if="fileType">
          <embed class="embed-preview"
                 :src="getPreview.url">
        </div>
      </b-modal>

      <!-- MODAL GLOBAL -->
      <!-- a ideia é esse modal servir para várias coisas -->
      <!-- no futuro será melhor simplificado -->
      <modal-global />
    </div>
  </div>
</template>

<script>
  /* components */
  import AppHeader from '@/components/AppHeader'
  import LockLoading from '@/components/LockLoading'
  import SideBarModules from '@/components/SideBarModules'
  import AppFooter from '@/components/AppFooter'
  import Loader from '@/components/Loader'
  import AppSubHeader from '@/components/AppSubHeader'
  import SideBarReleasesNotes from '@/components/SideBarReleasesNotes'

  /* services */
  import CartorioService from "@/services/CartorioService"
  import PapelSegurancaLoteService from '@/services/PapelSeguranca/PapelSegurancaLoteService'
  import CustasService from '@/services/Registros/CustasService'
  /* others */
  import { mapGetters } from 'vuex'
  import { getCurrentModule } from '@/helpers/defaultModule'

  export default {
    name: 'App',
    components: {
      AppHeader,
      SideBarModules,
      AppFooter,
      LockLoading,
      Loader,
      AppSubHeader,
      SideBarReleasesNotes
    },

    data () {
      return {
        lock: true,
        scrolled: false,
        getCurrentModule,
        module: {},
        status: null,
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorioObj: 'auth/getCartorioObj',
        getLoaderStatus: 'auth/getLoaderStatus',
        getSidebarStatus: 'auth/isSidebarOpen',
        getPreview: 'file/getPreview',
        fileType: 'file/getType',
        resize: 'window/getScroll',
        window: 'window/getWindow',
        logged: 'auth/confirmLogin',
        user: 'auth/getUser',
        userToken: 'auth/getUserToken',
        primeiroAcesso: 'auth/getCartorioPrimeiroAcesso',
        userTokenIDRC: 'auth/getTokenIDRC'
      }),
      wrapperClass () {
        return [
          this.$route.name
        ]
      },
      isLoggedIn () {
        return this.$store.state.auth.isLoggedIn
      },
    },
    watch: {
      $route: function (to) {
        const { path } = to

        if (to.query && to.query.redirect) {
          this.$router.replace({ 'query': null } )
        }

        if (to.query && to.query.usernotfound) {
          this.$router.replace({ 'query': null } ).then(async () => {
            return this.onLoginError('Erro', 'Usuário não encontrado')
          })
        }

        if (path !== '/login' && path != '/acessar-cartorio' && path !== '/icp') {
          const flag_oficial = this.user ? this.user.flag_oficial : false

          if (!this.primeiroAcesso && flag_oficial && path != '/primeiro-acesso') {
            this.$router.push('/primeiro-acesso')
          } else if (this.primeiroAcesso && path == '/primeiro-acesso') {
            this.$router.push('/')
          }
        }

        // informa a listagem de menu
        this.module = this.getCurrentModule(path)
      },
    },
    async created () {
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleResize)
      await this.getPapeis()
    },
    beforeMount () {
      
      const pathName = window.location.pathname
      const tokenIDRC = window.localStorage.getItem('token-idrc')
      const userCheckId = new URLSearchParams(window.location.search.substring(1)).get('redirect')

      if (!this.user && pathName == '/' && userCheckId) {
        this.$store.dispatch('auth/checkLogin', userCheckId).then(async (checkResponse) => {
          if (!checkResponse) return this.$router.push({ name: 'login' })
          this.lock = true
          loader({active: true})
          const {isLoggedIn} = this.$store.state.auth
          if (!isLoggedIn && this.$route.meta.loginRequired) {
            return this.$router.push({name: 'login'})
          }

          this.module = this.getCurrentModule(this.$route.path)

          if (!this.cartorioId && this.user.cartorio_id) {
            const {data: cartorio} = await CartorioService.getCartorioRei(this.user.cartorio_id)
            const flag_oficial = this.user ? this.user.flag_oficial : false

            if (cartorio) {
              this.$store.dispatch('auth/setPrimeiroAcesso', cartorio.primeiro_acesso)

              if (!this.primeiroAcesso && flag_oficial) {
                this.$router.push('/primeiro-acesso')
              } else if (this.$route.path === '/primeiro-acesso') {
                this.$router.push('/')
              } else {
                this.$router.push({ name: 'acessar_cartorio' })
              }
            }
          } else if (!this.cartorioId) {
            return this.$store.dispatch('auth/logout').then(() => this.$router.push({ name: 'login' }))
          } else {
            /**
             * Verificamos novamente o status do primeiro acesso ao recarregar
             * a página
             */

            const {data: cartorio} = await CartorioService.getCartorioRei(this.cartorioId)
            const flag_oficial = this.user ? this.user.flag_oficial : false

            if (cartorio) {
              this.$store.dispatch('auth/setPrimeiroAcesso', cartorio.primeiro_acesso)

              if (!this.primeiroAcesso && flag_oficial) {
                this.$router.push('/primeiro-acesso')
              } else if (this.$route.path === '/primeiro-acesso') {
                this.$router.push('/')
              }
            }
          }
        }).catch((error) => {
          const message = error.response.data.message || 'Usuário não encontrado.'

          this.onLoginError('Erro', message)
        }).finally(() => {
          this.lock = false
          loader({active: false})
        })
      } else if (pathName && pathName !== '/login' && pathName !== '/atendimento' && pathName !== '/icp') {
        if (pathName == '/icp') {
          if (process.env.NODE_ENV === 'production') {
            window.location.href = 'https://idrc.registrocivil.org.br/realms/IDRC/protocol/openid-connect/auth?scope=openid+email+celular+address+data_nascimento+cidade_nascimento+uf_nascimento+foto_de_perfil_url+data_obito&state=rZ-0GxBtRM6UIfUMPh8HpI2iX--HKIRmVLC6T1oLk2U.FdCvGSsXZec.mQx2YAz0SsKbVwaR8JlblA&response_type=code&client_id=sofia-api&redirect_uri=https%3A%2F%2Fsprc.registros.org.br%2Frealms%2FSPRC%2Fbroker%2FICPBrasil%2Fendpoint&nonce=TCDNG0y15y9CUR2HvEdipw'
          }
          else {
            window.location.href = 'https://idrch.registrocivil.org.br/realms/IDRC/protocol/openid-connect/auth?client_id=home_icp&scope=openid+foto_de_perfil_url&response_type=code&redirect_uri=https%3A%2F%2Fwww.homeh.registrocivil.org.br%2Fapi%2Flogin-callback&acr_values=urn%3Aidrc%3Aloa%3Asubstancial'
          }  
        }
        this.$store.dispatch('auth/check', this.userToken).then(async (checkResponse) => {
          if (!checkResponse) return this.$router.push({ name: 'login' })

          const {isLoggedIn} = this.$store.state.auth

          if (!isLoggedIn && this.$route.meta.loginRequired) {
            return this.$router.push({name: 'login'})
          }

          this.module = this.getCurrentModule(this.$route.path)

          if (!this.cartorioId && this.user.cartorio_id) {
            const {data: cartorio} = await CartorioService.getCartorioRei(this.user.cartorio_id)
            const flag_oficial = this.user ? this.user.flag_oficial : false

            if (cartorio) {
              this.$store.dispatch('auth/setPrimeiroAcesso', cartorio.primeiro_acesso)
              
              if (!this.primeiroAcesso && flag_oficial) {
                this.$router.push('/primeiro-acesso')
              } else if (this.$route.path === '/primeiro-acesso') {
                this.$router.push('/')
              } else {
                this.$router.push({ name: 'acessar_cartorio' })
              }
            }
          } else if (!this.cartorioId) {
            return this.$store.dispatch('auth/logout').then(() => this.$router.push({ name: 'login' }))
          } else {
            /**
             * Verificamos novamente o status do primeiro acesso ao recarregar
             * a página
             */
            const {data: cartorio} = await CartorioService.getCartorioRei(this.cartorioId)
            const flag_oficial = this.user ? this.user.flag_oficial : false

            if (cartorio) {
              this.$store.dispatch('auth/setPrimeiroAcesso', cartorio.primeiro_acesso)

              if (!this.primeiroAcesso && flag_oficial) {
                this.$router.push('/primeiro-acesso')
              } else if (this.$route.path === '/primeiro-acesso') {
                this.$router.push('/')
              }
            }
          }
        }).catch((error) => {
          const message = error.response.data.message || 'Usuário não encontrado.'

          this.onLoginError('Erro', message)
        }).finally(() => {
          this.lock = false
          loader({active: false})
        })
      } else if (pathName && (pathName == '/login' || pathName == '/icp') && tokenIDRC) {
        this.$store.dispatch('auth/check', tokenIDRC).then(async (checkResponse) => {
          if (!checkResponse) return this.$router.push({ name: 'login' })

          const {isLoggedIn} = this.$store.state.auth

          if (!isLoggedIn && this.$route.meta.loginRequired) {
            return this.$router.push({name: 'login'})
          }

          this.module = this.getCurrentModule(this.$route.path)

          if (!this.cartorioId && this.user.cartorio_id) {
            const {data: cartorio} = await CartorioService.getCartorioRei(this.user.cartorio_id)
            const flag_oficial = this.user ? this.user.flag_oficial : false

            if (cartorio) {
              this.$store.dispatch('auth/setPrimeiroAcesso', cartorio.primeiro_acesso)

              if (!this.primeiroAcesso && flag_oficial) {
                this.$router.push('/primeiro-acesso')
              } else if (this.$route.path === '/primeiro-acesso') {
                this.$router.push('/')
              } else {
                this.$router.push({ name: 'acessar_cartorio' })
              }
            }
          } else if (!this.cartorioId) {
            return this.$store.dispatch('auth/logout').then(() => this.$router.push({ name: 'login' }))
          } else {
            /**
             * Verificamos novamente o status do primeiro acesso ao recarregar
             * a página
             */
            const {data: cartorio} = await CartorioService.getCartorioRei(this.cartorioId)
            const flag_oficial = this.user ? this.user.flag_oficial : false

            if (cartorio) {
              this.$store.dispatch('auth/setPrimeiroAcesso', cartorio.primeiro_acesso)

              if (!this.primeiroAcesso && flag_oficial) {
                this.$router.push('/primeiro-acesso')
              } else if (this.$route.path === '/primeiro-acesso') {
                this.$router.push('/')
              }
            }
          }
        }).catch((error) => {
          const message = error.response.data.message || 'Usuário não encontrado.'

          this.onLoginError('Erro', message)
        }).finally(() => {
          this.lock = false
          loader({active: false})
        })
      } else {
        this.lock = false
        loader({ active: false })
      }

      this.$store.dispatch('procedimento/updateProcedimento', null)
      this.$store.dispatch('procedimento/updateRequerente', {})
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      handleScroll () {
        const values = { scrolled: window.scrollY > 0, value: window.scrollY }
        this.$store.dispatch('window/updateResize', values).then(() => false)
      },
      handleResize () {
        const sizes = { height: window.innerHeight, width: window.innerWidth }
        this.$store.dispatch('window/updateWindow', sizes).then(() => false)
      },
      clearPreview () {
        this.$store.dispatch('file/clearPreview').then(result => result)
      },
      closePreview () {
        this.$root.$emit('bv::hide::modal', 'previewModal')
        this.$store.dispatch('file/clearPreview').then(result => result)
      },
      onLoginError (title, text) {
        loader({ text: '', active: false })

        objSwal.error.title = title
        objSwal.error.text = text

        return Swal.fire(objSwal.error)
      },
      async getPapeis () {
        // pega os tipos de papeis e selos
        const data = await PapelSegurancaLoteService.listTipos()
        const tipoPapeis = [...data.tipos_de_papeis, ...data.tipos_de_selos]
        this.$store.dispatch('papeisSeguranca/setTiposPapeisSeguranca', tipoPapeis)
      }
    }
  }
</script>

<style lang="scss">
  @import './scss/_app';

  .app-wrapper {
    max-width: 100vw;
    min-height: 100vh;
    width: 100%;
  }

  .swal2-container, .loader--active {
    z-index: 1200 !important;
    background-color: rgba(35, 35, 35, 0.85) !important;
  }
</style>
